var mp = mp || {};

// Dropzone Upload
//-----------------------------------------------------------------
Dropzone.autoDiscover = false;

mp.dropzoneUpload = function() {
    var $element = $('.dropzone');
    if (!$element.length) {
        return;
    }

    var $dropzone = new Dropzone(".dropzone", { 
        paramName: 'files',
        maxFiles: 50,
        maxFilesize: 50, // MB
        acceptedFiles: 'image/*,application/pdf,application/zip,.doc,.docx,.xls,.xlsx',
        dictDefaultMessage: 'Drag and Drop files here or click to upload.',
    });

    $dropzone.on("success", function(file) {
        $response = JSON.parse(file.xhr.response);
        $data = $response.files[0];

        $update_database = true;
        if (typeof $response.update_database !== 'undefined') {
            $update_database = $response.update_database;
        }

        if ($response.files[0].error){
            $(file.previewElement).removeClass('dz-success').addClass('dz-error');
            $(file.previewElement).find('.dz-error-message span').text($response.files[0].error);
            
            return;
        }

        if ($update_database === true) {
            $.ajax({
              method: "POST",
              url: "update.php?update_type=media_add",
              data: $data,
            }).done(function(response){
                //console.log(response);
                //$dropzone.removeFile(file);
            });
        }
    });


    $dropzone.on("queuecomplete", function() {
        setTimeout(function(){
            $.get('ajax/media/media-list.php').done(function(data) {
                $('#media-list').html(data);
                mp.backgroundHolder();
            })
        }, 500);
    });
};



// Fancybox - Media
//-----------------------------------------------------------------
mp.fancyboxMedia = function() {
    var $element = $('[data-media]');

    if (!$element.length) {
        return;
    }

    $().fancybox({
        'selector'  : '[data-media]',
        'width'     : '100%',
        'type'      : 'ajax',
        'hash'      : false,
        'slideShow' : false,
        'touch'     : false,
        'keyboard'  : false,
        'arrows'    : false,
        'infobar'   : false,
        'filter'    : '#media-wrapper',
    });
};

$.fancybox.defaults.closeExisting = "true";



// Dropzone Toggle
//-----------------------------------------------------------------
mp.dropzoneToggle = function() {
    $(document).on('click', '[data-dropzone-toggle]', function(e){
        e.preventDefault();

        $('#media-uploader').removeClass("hidden");
    });
};



// Media Select
//-----------------------------------------------------------------
mp.mediaSelect = function() {
    $(document).on('click', '[data-media-select]', function(e){
        e.preventDefault();

        $fancybox = $.fancybox.getInstance();
        $trigger = $fancybox.$trigger;

        //console.log($trigger);

        if ($trigger) {
            $mediaType = $trigger.data('media');
        } else {
            $mediaType = $(this).data('media-type');
        }

        $media_id = $(this).data('media-select');

        if ($mediaType=="featured") {
            $mediaFeatured = $trigger.data('media-featured');

            $.post('ajax/media/featured-image.php', { media_id: $media_id, media_type: $mediaFeatured }).done(function(data) {
                if (data=="error") {
                    alert("Unexpected error, please try again!");
                } else {
                    $trigger.parent().prepend(data);
                    $trigger.addClass('hidden');
                    $fancybox.close();
                    $('#media-info.modal').modal('hide');

                    setTimeout(function(){
                        if ($trigger.data("trigger") == "modal") {
                            $("body").addClass("modal-open");
                        }
                    }, 500);
                }
            });
        }


        if ($mediaType=="file") {
            $.post('ajax/media/media-url.php', { media_id: $media_id}).done(function(data) {
                if (data=="error") {
                    alert("Unexpected error, please try again!");
                } else {
                    $trigger.parents('.media-file').find('input').val(data);
                    $fancybox.close();
                    $('.modal').modal('hide');
                }
            });
        }


        if ($mediaType=="editor") {
            $.post('ajax/media/media-url.php', { media_id: $media_id}).done(function(data) {
                if (data=="error") {
                    alert("Unexpected error, please try again!");
                } else {
                    $('.mce-window .mce-filepicker input').val(data);
                    $fancybox.close();
                    $('.modal').modal('hide');
                }
            });
        }


        if ($mediaType=="gallery") {
            $.post('ajax/media/gallery-image.php', { media_id: $media_id}).done(function(data) {
                if (data=="error") {
                    alert("Unexpected error, please try again!");
                } else {
                    $trigger.parents('.card').find('.gallery-list').prepend(data);
                    $fancybox.close();
                    $('.modal').modal('hide');
                    mp.backgroundHolder();
                }
            });
        }


        $('.modal-backdrop').remove();
        //console.log($mediaType);
        //console.log($fancybox.$trigger);
    });
};



// Media Remove
//-----------------------------------------------------------------
mp.mediaRemove = function() {
    $(document).on('click', '[data-media-remove="featured"]', function(e){
        e.preventDefault();

        $(this).offsetParent().find('[data-media="featured"]').removeClass('hidden');
        $(this).parent().remove();
    });

    $(document).on('click', '[data-media-remove="featured-variation"]', function(e){
        e.preventDefault();

        $(this).offsetParent().find('[data-media="featured-variation"]').removeClass('hidden');
        $(this).parent().remove();
    });


    $(document).on('click', '[data-media-remove="gallery"]', function(e){
        e.preventDefault();

        $(this).parents('.gallery-item').remove();
    });
};



// Media Select
//-----------------------------------------------------------------
mp.mediaInfoToggle = function() {
    $(document).on('click', '[data-media-item]', function(e){
        e.preventDefault();

        $media_id = $(this).data('media-item');
        $mediaType = $(this).data('media-type');
        $mediaAction = $(this).data('media-action');

        $.post('ajax/media/media-info.php', { media_id: $media_id, media: $mediaType, media_action: $mediaAction }).done(function(data) {
            if (data=="error") {
                $('#media-info').find('.media-info-content').html('<p>Unexpected error, please try again!</p>');
            } else {
                $('#media-info').find('.media-info-content').html(data);
                $('#media-info').modal();
            }
        });
    });



    var $timeoutId;
    $(document).on('propertychange change', '#form-media-info input, #form-media-info textarea', function(e) {
        $form_element = $(this);

        clearTimeout($timeoutId);
        $timeoutId = setTimeout(function() {
            saveToDB($form_element);
        }, 1000);
    });

    $(document).on('submit', '#form-media-info', function(e) {
        e.preventDefault();
        saveToDB();
    });

    function saveToDB($form_element) {
        $form = $('#form-media-info');
        
        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: $form.serialize(),
            beforeSend: function(xhr) {
                
            },
            success: function(data) {
                $form_element.parent().find('.response').remove();
                $form_element.parent().append('<span class="response">'+data+'</span>').find('.response').hide().fadeIn();

                setTimeout(function() {
                    $form_element.parent().find('.response').fadeOut(function(){
                        $(this).remove();
                    });
                }, 3000);
            }
        });
    }
};



// Copy Input Value
//-----------------------------------------------------------------
mp.copyInputVal = function() {
    $(document).on('click', '.js_copyInputVal', function(e){
        e.preventDefault();

        $val = $(this).offsetParent().find('input').select();
        document.execCommand("copy");
    });
};


// Get media list
//-----------------------------------------------------------------
mp.getMediaList = function() {
    var $element = $("#media-list");

    if (!$element.length) {
        return;
    }

    $(document).on('click', '[data-get-list-page]', function(e){
        e.preventDefault();

        $page = $(this).data("get-list-page");
        $(this).parent().remove();

        getMediaList($page);
    });

    getMediaList();
    mp.searchMediaList();
};

function getMediaList($page, $q) {
    var $element = $("#media-list");

    $.get('ajax/media/media-list.php', { p: $page, q: $q }).done(function(response) {
        $element.append(response);

        mp.backgroundHolder();
    });
}


// Search media list
//-----------------------------------------------------------------
mp.searchMediaList = function() {
    var $element = $("[data-media-search]");

    if (!$element.length) {
        return;
    }

    //setup before functions
    var typingTimer;                //timer identifier
    var doneTypingInterval = 1000;  //time in ms (5 seconds)

    //on keyup, start the countdown
    $element.on("input", function(){
        clearTimeout(typingTimer);
        typingTimer = setTimeout(doneTyping, doneTypingInterval);
    });

    //user is "finished typing," do something
    function doneTyping() {
        $("#media-list").html("");

        $value = $element.val();
        getMediaList(1, $value)
    }
};






$(document).ready(function (){
    mp.dropzoneUpload();
    mp.dropzoneToggle();
    mp.mediaSelect();
    mp.mediaRemove();
    mp.mediaInfoToggle();
    mp.copyInputVal();
    mp.fancyboxMedia();
    mp.getMediaList();
});